import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "./lib/i18n";
import { AuthProvider, ProtectedRoute } from "./lib/auth";
import { TintDefs } from "./lib/filters";
import Landing from "./pages/Landing";
import Studio from "./pages/Studio";
import Creations from "./pages/Creations";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Account from "./pages/Account";
import { Recharge, PaymentSuccess, PaymentCancel } from "./pages/Payments";
import { ForgotPassword, ResetPassword } from "./pages/PasswordPages";

const Guard = (el) => <ProtectedRoute>{el}</ProtectedRoute>;

function AppRouter() {
  const location = useLocation();
  // Process the Google session_id synchronously before any other route renders.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/studio" element={Guard(<Studio />)} />
      <Route path="/studio/:id" element={Guard(<Studio />)} />
      <Route path="/creations" element={Guard(<Creations />)} />
      <Route path="/account" element={Guard(<Account />)} />
      <Route path="/recharge" element={Guard(<Recharge />)} />
      <Route path="/payment/success" element={Guard(<PaymentSuccess />)} />
      <Route path="/payment/cancel" element={Guard(<PaymentCancel />)} />
    </Routes>
  );
}

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <TintDefs />
        <Toaster position="top-right" theme="dark" richColors />
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
